// JavaScript source code
import React, { useEffect, useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import dataJoinUs from '../assets/fake-data/data-joinus';
import Header from '../components/header';
import SubFooter from '../components/subfooter';
import Input from '../components/input';
import Button from '../components/button';
import { get, post, getBaseURL, getUser} from '../request';
import CheckBox from '../components/checkbox';
import MessageDialog from '../components/messageDialog';
import LoadingOverlay from '../components/loadingOverlay';
import config from '../config';
import LoginDialog from '../components/loginDialog';

function JoinUsStep1(props) {    
    let activeIndex = 3;
    var baseURL = getBaseURL();
    const theData = dataJoinUs;
    const [isShowLogin, setIsShowLogin] = useState(false);
    var user = getUser();
    const finishLogin = () => {
        setIsShowLogin(false);
        //navigate("/JoinUsStep");
        user = getUser();
    }
    useEffect(() => {
        
        getVarCodeImg();
    }, []);
    const navigate = useNavigate();
   
    const [item, setInputs] = useState({
        externalName: '',
        loginName: '',
        jointype: 0,
        userType:1
        // 可以根据需要添加更多输入字段  
    });

    const handleInputChange = (name, value) => {
        setInputs({ ...item, [name]: value });
        if (name == "agreeCompany") {
            handleValidInput(name, value);
        }
    };
    const [isValid, setIsValid] = useState({
        externalName: false,
        loginName: false,
        password: false,
        passwordverfiy: false,
        name: false,
        varcode2: false,
        phone: false,
        varcode: false,
        agreeCompany: false

    });
    const [formIsValid, setFormIsValid] = useState(false);
    const [varCodeImg, setVarCodeImg] = useState("");
    const [sessionId, setSessionId] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [second, setSecond] = useState(60);
    const [paracont, setParacont] = useState("获取验证码");
    const [paraevent, setParaevent] = useState(true);
    const [isLoading, setShowLoading] = useState(false);
    var second1 = 60;
    const getNumber = () => {        
        const intervalId = setInterval(() => {
            //setCount(prevCount => prevCount + 1);
            if (second1 <= 0) {
                clearInterval(intervalId);
                setSecond(60);
                second1 = 60;
                setParacont("重发验证码");
                setParaevent(true);
            }
            else {
                second1 = second1 - 1;
                setParacont(second1 + "秒后可重发");
                setSecond(second1);
                setParaevent(false);
            }
        }, 1000);
        // 清除定时器，避免在组件卸载后继续执行  
        //return () => clearInterval(intervalId);
    };
    const getVarCodeImg = () => {
        setShowLoading(true);
        post("delianapi/login/clearcodenew", { sessionId: sessionId }).then((response) => {
            setShowLoading(false);
            if (response.statusCode == 200 && response.items.length > 0) {
                setSessionId(response.items[0]);
                setVarCodeImg(baseURL + "/delianapi/login/code?sessionId=" + response.items[0] +"&width=" + 100 + "&height=" + 45 + "&v=" + Math.random());
            }

        });
    };
    const sendphonecode = () => {
        setShowLoading(true);
        get("delianapi/sms/code?sessionId=" + sessionId +"&phone=" + item.phone + '&varcode2=' + item.varcode2
            + '&t=' + Math.random())
            .then(response => {
                setShowLoading(false);                
                if (response.statusCode == 200) {
                    getNumber();
                } else {
                    //$danger.show();
                    setErrorMessage(response.message);
                    getVarCodeImg();
                    return;
                }
            });      
    };
   
    const handleClick = () => {
        setSuccessMessage("");
        setErrorMessage("");
        item.jointype = 0;
        item.userType = 1;
        item.sessionId = sessionId;
        setShowLoading(true);
        post('delianapi/user/register', item).then((response) => {
            setShowLoading(false);
            if (response.statusCode == 200) {
                var loginItem = response.items[0];
                localStorage.setItem('Authorization', loginItem.userHash);
                get('delianapi/user/userinfo').then((response) => {
                    var loginItem = response.items[0];
                    localStorage.setItem('user', JSON.stringify(loginItem.user));
                    navigate(config.root + '/JoinUsStep2');
                });
                setSuccessMessage("欢迎注册德联车护");

            } else {
                setErrorMessage(response.message);
                getVarCodeImg();
                return;
            }
        });
    };

    const handleValidInput = (name, isNewValid) => {
        setIsValid(isValid => {
            isValid[name] = isNewValid;
            return isValid;
        });
        validateForm();
    }
    const validateForm = () => {
        const timer = setTimeout(() => {
            const isAllFieldsFilled = Object.values(isValid).every(value => value);
            setFormIsValid(isAllFieldsFilled);
            clearTimeout(timer);
        }, 10);
    };
    return (      
        <div className={`aboutUs joinUs`} >
            <Header activeIndex={activeIndex} user={user} setIsShowLogin={setIsShowLogin}/>
            <div className="content js_content">
                <div className="pageHead">
                    <div className="pageTitle">{theData.pageTitle}</div>
                    <div className="pageSubTitle">{theData.pageSubTitle}</div>
                    <div className="pageDetail">{theData.pageDetail}</div>
                </div>
                <div className="subcontent">
                    <div className="title">服务商注册</div>
                        <div className="step_content">
                        <div className="step_detail step_detail1">
                            <Input className="input" placeholder="公司名称(必填)" value={item.externalName} checkRequied={true}
                                name="externalName" onChange={value => handleInputChange('externalName', value)} onValidInput={handleValidInput}
                                    checkUniq={true} entityId={0} validType="Business" columnName="Name" />
                                <Input className="input" placeholder="用户名(6-20个字符，建议使用数字、字符、字母混合)" value={item.loginName}
                                name="loginName" onChange={value => handleInputChange('loginName', value)} onValidInput={handleValidInput}
                                checkUniq={true} entityId={0} validType="User" columnName="LoginName" checkRequied={true}
                                    minLength="6" maxLength="20" />
                            <Input inputType="password" className="input" placeholder="设置密码 (6-20个字符，建议使用数字、字符、字母混合)"
                                value={item.password} minLength="6" maxLength="20" checkRequied={true} onValidInput={handleValidInput}
                                    name="password" onChange={value => handleInputChange('password', value)} />
                            <Input inputType="password" className="input" placeholder="确认密码" value={item.passwordverfiy} checkRequied={true} onValidInput={handleValidInput}
                                    name="passwordverfiy" onChange={value => handleInputChange('passwordverfiy', value)}
                                    minLength="6" maxLength="20" />
                            <Input className="input" placeholder="联系人" value={item.name} checkRequied={true} onValidInput={handleValidInput}
                                    name="name" onChange={value => handleInputChange('name', value)} />
                                <div className="inputDiv">
                                <Input className="input smallInput" placeholder="图形验证码" value={item.varcode2} onValidInput={handleValidInput}
                                    checkRequied={true} name="varcode2" onChange={value => handleInputChange('varcode2', value)} />
                                    <div className="imgDiv" onClick={getVarCodeImg}>
                                        <img src={varCodeImg} className="varCode" alt="" />
                                    </div>
                                </div>
                                <div className="inputDiv">
                                <Input className="input smallInput" placeholder="手机号码" value={item.phone} onValidInput={handleValidInput}
                                    name="phone" onChange={value => handleInputChange('phone', value)} checkRequied={true}
                                        checkUniq={true} entityId={0} validType="User" columnName="Phone" />
                                    <div className="col-right">
                                    <button className={`btn-send ${item.phone && item.varcode2 && paraevent ? '' : 'btn-bgcolor'}`} onClick={sendphonecode}
                                        disabled={!(item.phone && paraevent && item.varcode2)} >
                                            {paracont}
                                        </button>
                                    </div>
                                </div>
                            <Input className="input" placeholder="短信验证码" value={item.varcode} onValidInput={handleValidInput}
                                checkRequied={true} name="varcode" onChange={value => handleInputChange('varcode', value)} />
                            </div>
                            <div className="inputDiv checkboxDiv">
                            <CheckBox checkRequied={true} title="我已阅读并同意" name="agreeCompany" value={item.agreeCompany}
                                onChange={value => handleInputChange('agreeCompany', value)} />

                            <a className="blue" href={config.root + "/Agreement"} target="_blank">《德联用户注册协议》</a>
                            </div>
                        <Button btnclass={`join_btn `} onClick={handleClick} title="注&nbsp;&nbsp;册" disabled={!formIsValid}/>

                        </div>
                </div>

            </div>
            <SubFooter />
            <MessageDialog message={successMessage || errorMessage} onCancel={() => {
                setSuccessMessage("");
                setErrorMessage("");
            }} />
            <LoginDialog isShowLogin={isShowLogin} onCancel={finishLogin} />

            <LoadingOverlay isLoading={isLoading}>
            </LoadingOverlay>
        </div>
          
    );
}

export default JoinUsStep1;